export default window.staticConfiguration ?? {};